import { defineComponent as S, useAttrs as $, ref as g, useSlots as L, computed as n, openBlock as i, createBlock as d, Transition as M, withCtx as p, createElementBlock as a, mergeProps as T, unref as c, createVNode as b, toDisplayString as r, createCommentVNode as o, renderSlot as v, createTextVNode as z } from "vue";
import V from "./novoui-vuejs2.js";
import y from "./novoui-vuejs12.js";
import { NotificationTypeEnum as E, getNotificationStyleClasses as F, getNotificationIcon as I } from "./novoui-vuejs68.js";
const O = {
  key: 0,
  class: "notification-interim-title"
}, w = {
  key: 3,
  class: "notification-interim-body"
}, H = /* @__PURE__ */ S({
  inheritAttrs: !1,
  __name: "NNotification",
  props: {
    type: { default: E.info },
    title: {},
    content: {},
    buttonLabel: {},
    buttonMethod: {},
    notDismissible: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    icon: {}
  },
  emits: [
    /**
     * Event emitted when the user clicks the close notification button
     */
    "update:close",
    /**
     * Event emitted when the user clicks the action button in the footer
     */
    "update:action"
  ],
  setup(k, { emit: h }) {
    const { class: C, ...N } = $(), s = g(!1), u = h, l = L(), t = k;
    function _(e) {
      t.buttonMethod && t.buttonMethod(), u("update:action", e);
    }
    function B(e) {
      s.value = !0, u("update:close", e);
    }
    const f = n(() => t.title && t.title.trim()), m = n(() => t.content && t.content.trim() || l.default), A = n(() => F(t)), D = n(() => I(t.type, t.icon));
    return (e, P) => (i(), d(M, {
      "enter-from-class": "notification-interim-enter-from",
      "enter-active-class": "notification-interim-enter-active",
      "leave-to-class": "notification-interim-leave-to",
      "leave-active-class": "notification-interim-leave-active"
    }, {
      default: p(() => [
        (typeof e.$attrs["v-if"] > "u" || e.$attrs["v-if"]) && !s.value ? (i(), a("div", T({
          key: 0,
          "data-testid": "notification",
          class: [c(C), A.value]
        }, N), [
          b(y, {
            icon: D.value,
            class: "notification-interim-icon",
            size: 24
          }, null, 8, ["icon"]),
          t.title && t.title.trim() ? (i(), a("h5", O, r(t.title), 1)) : o("", !0),
          f.value && m.value && !t.notDismissible ? (i(), a("button", {
            key: 1,
            "aria-label": "Close notification",
            "data-testid": "notification-close-button",
            class: "notification-interim-close",
            onClick: B
          }, [
            b(y, {
              size: 16,
              icon: "close"
            })
          ])) : o("", !0),
          c(l).default ? v(e.$slots, "default", { key: 2 }) : t.content && t.content.trim() ? (i(), a("p", w, r(t.content), 1)) : o("", !0),
          c(l).notificationFooter ? v(e.$slots, "notificationFooter", { key: 4 }) : t.buttonLabel && t.buttonLabel.trim() && t.buttonMethod && f.value && m.value ? (i(), d(V, {
            key: 5,
            class: "button-notification",
            size: "small",
            onClick: _
          }, {
            default: p(() => [
              z(r(t.buttonLabel), 1)
            ]),
            _: 1
          })) : o("", !0)
        ], 16)) : o("", !0)
      ]),
      _: 3
    }));
  }
});
export {
  H as default
};
